import React, { useState, useEffect, useContext, useRef } from 'react';
import styles from './styles.module.css';
import { gift } from 'assets/gifs';
import {
  tick,
  medal,
  first_month,
  second_month,
  third_month,
  fourth_month,
  fifth_month,
  arrow_up,
  arrow_down,
  arrow_up_black,
  arrow_down_black,
} from 'assets/icons';
import { copyLinkIcon } from 'assets/newIcons';
import MobileContext from 'context/MobileContext';
import { useSelector } from 'react-redux';

const ReferralOverview = ({ loadBuddyReferralDetails, buddyReferralDetails }) => {
  const isMobile = useContext(MobileContext);
  let sfId = localStorage.getItem('sfId');
  const olsUrl = process.env.REACT_APP_NEW_OLS_URL;
  const linkToCopy = `${olsUrl}?m=${sfId}`;
  const [copied, setcopied] = useState(false);
  const userID = useSelector(state => state?.auth?.profile?.userID);
  const userFirstName = useSelector(state => state?.auth?.user?.firstName);
  const referralText = useSelector(state => state?.auth?.profile?.referralText);
  const [showAll, setShowAll] = useState(false);
  const {
    hasReferral = false,
    monthsEarned,
    referralMessage,
    referralData,
    popUpTitle1,
    popUpTitle2,
    popUpDescription,
    hasShortTermPass,
  } = buddyReferralDetails;
  const displayedData = showAll ? referralData : referralData?.slice(0, 5);
  const displayedDataMobile = showAll ? referralData : {};
  const datasLengthMobile = displayedDataMobile?.length;

  const emojis = [first_month, second_month, third_month, fourth_month, fifth_month];
  const emoji = monthsEarned <= 4 ? emojis[monthsEarned - 1] : emojis[4];

  useEffect(() => {
    loadBuddyReferralDetails(userID);
  }, []);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(linkToCopy);
      setcopied(true);
    } catch (err) {}
  };

  const handleToggleShowAll = () => {
    setShowAll(!showAll);
  };

  const handleCopyLink = async () => {
    if (linkToCopy) {
      if (navigator.share) {
        try {
          const shareData = {
            text: `${userFirstName} has invited you to join FITNESS SF.\n\n${referralText}\n\u00A0\n`,
            url: linkToCopy,
          };
          await navigator.share(shareData);
        } catch (err) {
          console.log('Error: ', err);
        }
      } else {
        alert('Native Web Sharing not supported');
      }
    }
  };

  const handleJoinClick = () => {
    window.open(olsUrl, '_blank');
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setcopied(false);
      }, 10000);
    }
  }, [copied]);

  return (
    <div className={styles.body}>
      <div className={hasReferral ? styles.container : styles.newContainer}>
        <img src={gift} alt="gif" className={styles.gift} />
        <h2 className={styles.heading}>
          {popUpTitle1}
          {isMobile ? <br /> : ''} {popUpTitle2}
        </h2>
        <div
          dangerouslySetInnerHTML={{
            __html: popUpDescription,
          }}
          className={styles.subHeading}
        />
        {!hasShortTermPass ? (
          !isMobile ? (
            <div className={styles.linkContainer}>
              <div className={styles.subLinkContainer}>
                <p>{linkToCopy}</p>
                <div>
                  <img
                    height={25}
                    width={25}
                    alt=""
                    onClick={copyToClipboard}
                    src={copied ? tick : copyLinkIcon}
                  />
                </div>
              </div>
            </div>
          ) : (
            <button
              onClick={() => (isMobile ? handleCopyLink() : '')}
              className={styles.linkButton}
            >
              {hasReferral ? 'Get More Rewards!' : 'Get Rewarded!'}
            </button>
          )
        ) : (
          <button onClick={handleJoinClick} className={styles.joinButton}>
            Join Now!
          </button>
        )}
        {hasReferral && !hasShortTermPass ? (
          <div className={styles.referralContainer}>
            <hr className={styles.mainDivider} />
            <div className={styles.referralHeading}>
              <img src={medal} alt="" className={styles.medalIcon} />
              <p className={styles.text}>My Referral Rewards</p>
            </div>
            <div className={styles.countContainer}>
              <div className={styles.medalHeading}>
                <img src={emoji} alt="" className={styles.countIcon} />
                <p className={styles.referralMsg}>{referralMessage}</p>
              </div>
              <div className={styles.countsText}>
                <p className={styles.count}>{monthsEarned}</p>
                <p className={styles.monthsText}>
                  {monthsEarned === '1' ? 'Month Earned' : 'Months Earned'}
                </p>
              </div>
            </div>
            {!isMobile ? (
              <div className={styles.detailsContainer}>
                <p className={styles.text1}>My Referrals</p>
                <hr className={styles.divider} />
                <div className={`${styles.details}`}>
                  {displayedData?.map((data, index) => {
                    return (
                      <div className={styles.text2} key={index}>
                        <p className={styles.name}>{data.name}</p>
                        <p className={styles.date}>{data.referralDate}</p>
                      </div>
                    );
                  })}
                </div>
                {referralData?.length > 5 && (
                  <div
                    onClick={handleToggleShowAll}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <button className={styles.button}>
                      {!showAll ? 'See more' : 'See less'}
                    </button>
                    <img
                      src={showAll ? arrow_up : arrow_down}
                      alt=""
                      className={styles.arrowIcon}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div
                className={`${styles.detailsContainer} ${
                  showAll ? styles.expanded : styles.collapsed
                }`}
                style={!showAll ? { marginBottom: '25px' } : { marginBottom: '0px' }}
              >
                <div
                  onClick={handleToggleShowAll}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <p className={styles.text1}>My Referrals</p>
                  <img
                    src={showAll ? arrow_up_black : arrow_down_black}
                    alt=""
                    className={styles.arrowIcon}
                  />
                </div>
                {showAll ? (
                  <>
                    <hr className={styles.divider} />
                    <div
                      className={`${styles.details} ${
                        showAll && datasLengthMobile > 5 ? styles.scroll : ''
                      }`}
                    >
                      {displayedDataMobile?.map((data, index) => {
                        return (
                          <div className={styles.text2} key={index}>
                            <p className={styles.name}>{data.name}</p>
                            <p className={styles.date}>{data.referralDate}</p>
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ReferralOverview;
